import React, { useState, useEffect } from 'react'
import './Registration.scss'
import axios from 'axios'
import { connect } from 'react-redux'
import * as _ from 'lodash'
import { setUserActive, showPopup } from '../actions'
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { DobleGuion } from '../components/DobleGuion'
import { comprobarDatos } from '../hooks/validateForm'
import { Link } from 'react-router-dom'
import { API } from '../hooks/config'
import {UserPassLogin } from '../utils/icons';
const Registration = (props) => {
    const [acceptPrivacy, setAcceptPrivacy] = useState(false)
    const { clickChangeRegistrationLogin, zones } = props
    const [newUser, setNewUser] = useState({
        id: null,
        company: '',
        cif: '',
        name: '',
        phoneNumber: '',
        zone: '',
        email: '',
        password: '',
        role: 'basic',
    })

    const reglas = {
        email: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
            email: { message: 'con un formato invalido' },
        },
        company: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
        },
        cif: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
        },
        name: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
        },
        phoneNumber: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
            format: { pattern: '[0-9]+', message: 'solo puede contener digitos del 0 al 9' },
        },
        zone: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
        },
        password: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
        }
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setNewUser(() => ({
            ...newUser,
            [name]: value
        }))
    }

    const handleClickRegistation = () => {
        const alias = {
            company: 'empresa',
            name: 'nombre',
            phoneNumber: 'teléfono',
            zone: 'zona',
        }
        comprobarDatos(newUser, reglas, alias).then(res => {
            const headers = {
                headers: {
                    'Content-Type': 'application/json',
                }
            };
            axios.post(`${API}/new-user`, {
                id: newUser.id,
                company: newUser.company,
                cif: newUser.cif,
                name: newUser.name,
                phoneNumber: newUser.phoneNumber,
                zone: newUser.zone,
                email: newUser.email,
                role: newUser.role,
                password: newUser.password
            }, headers).then(res => {
                props.showPopup({
                    active: true, message: 'Usuario registrado. En caso de que no recuerdes la contraseña, la recibirás para acceder a tu cuenta en tu correo electrónico. Si tienes algún problema, contacta por favor con info@fansa.es', type: 'success'
                })
                clickChangeRegistrationLogin('login')
            }).catch(err => {
                props.showPopup({ active: true, message: 'Error en el registro', type: 'error' })
            });
        }).catch(err => {
            props.showPopup({ active: true, message: err, type: 'error' })
        })
    }

    return (
        <div className="registration-component-container">
            <div className="header">
                <div className="data">
                    <p>Registrate ahora </p>
                    <DobleGuion />
                </div>
            </div>
            <div className="registration-component-content">
                <div className="form-registation">
                    <div className="input-block email">
                        <label htmlFor="email">Email *</label>
                        <div className="input">
                            <input type="text" name="email" onChange={handleChange} value={newUser.email} />
                        </div>
                    </div>
                    <div className="input-block company">
                        <label htmlFor="company">Empresa *</label>
                        <div className="input">
                            <input type="text" name="company" onChange={handleChange} value={newUser.company} />
                        </div>
                    </div>
                    <div className="input-block cif">
                        <label htmlFor="cif">CIF *</label>
                        <div className="input">
                            <input type="text" name="cif" onChange={handleChange} value={newUser.cif} />
                        </div>
                    </div>
                    <div className="input-block name">
                        <label htmlFor="name">Nombre y apellidos *</label>
                        <div className="input">
                            <input type="text" name="name" onChange={handleChange} value={newUser.name} />
                        </div>
                    </div>
                    <div className="input-block phoneNumber">
                        <label htmlFor="phoneNumber">Teléfono *</label>
                        <div className="input">
                            <input type="text" name="phoneNumber" onChange={handleChange} value={newUser.phoneNumber} />
                        </div>
                    </div>
                    <div className="input-block pass">
                        <label htmlFor="pass">Contraseña *</label>
                        <div className="input">
                            <input type="password" name="password" onChange={handleChange} value={newUser.password} />
                             <UserPassLogin size={20} />
                        </div>
                    </div>
                    <div className="input-block select">
                        <label htmlFor="zone">Zona *</label>
                        <Select
                            MenuProps={{
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left"
                                },
                                transformOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                getContentAnchorEl: null
                            }}
                            name="zone"
                            IconComponent={ArrowForwardIosIcon}
                            value={newUser.zone}
                            id="select"
                            onChange={handleChange}>
                            <MenuItem value="">Elija una opción</MenuItem>
                            {zones.region.map((zone, index) => {
                                return (
                                    <MenuItem className={zones.region.length - 1 === index ? "regions-end" : ""} value={zone.Name} key={index}>{zone.Name}</MenuItem>
                                )
                            })}
                            {zones.country.map((zone, index) => {
                                return (
                                    <MenuItem value={zone.Name} key={index}>{zone.Name}</MenuItem>
                                )
                            })}
                        </Select>
                    </div>
                </div>
                <div className="privacy-policies">
                    <input className="oculto accept" id="accept" type="checkbox" name="accept" onChange={() => setAcceptPrivacy(!acceptPrivacy)} value={acceptPrivacy} />
                    <label className="check-automatico" htmlFor="accept">
                        <p></p>
                    </label>
                    <label className="check-data" htmlFor="checkbox">Acepto la <Link to="/politica-de-privacidad">política de privacidad</Link> y confirmo que mi información personal se puede utilizar de acuerdo con la ley. *</label>
                </div>
                <div className="required">
                    <p>*Campos obligatorios</p>
                </div>
                <div className="buttons">
                    {
                        acceptPrivacy ?
                            <button className="btn" onClick={handleClickRegistation}>Finalizar</button>
                            :
                            <button className="btn btn-light no-pointer">Finalizar</button>
                    }
                </div>
                <div className="go-login">
                    <p>¿Ya eres usuario?</p>
                    <a className="pointer" onClick={() => clickChangeRegistrationLogin('login')}>Accede ahora</a>
                </div>
            </div>
        </div>
    )
}

const mapDispatchToProps = {
    setUserActive,
    showPopup
}

const mapStateToProps = state => state

export default connect(mapStateToProps, mapDispatchToProps)(Registration)
